"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CReceipt = void 0;
var enums_1 = require("../../account/enums");
var currency_amount_1 = require("./currency-amount");
var CReceipt = /** @class */function () {
  function CReceipt(values) {
    this.items = [];
    this.total = new currency_amount_1.CCurrencyAmount({
      amount: 0,
      currency_id: enums_1.CurrencyEnum.usd
    });
    this.balance_changes = [];
    var instance = this;
    if (!values) {
      values = {};
    }
    for (var _i = 0, _a = Object.keys(values); _i < _a.length; _i++) {
      var _key = _a[_i];
      var key = _key;
      if (values[key]) {
        instance[key] = values[key];
      }
    }
    if (values.total) {
      instance.total = new currency_amount_1.CCurrencyAmount(values.total);
    }
    if (values.items) {
      instance.items = values.items.map(function (v) {
        return __assign(__assign({}, v), {
          amount: new currency_amount_1.CCurrencyAmount(v.total_amount),
          total_amount: new currency_amount_1.CCurrencyAmount(v.total_amount)
        });
      });
    }
    return instance;
  }
  CReceipt.prototype.addItem = function (item, includeInTotal) {
    var _a, _b;
    if (includeInTotal === void 0) {
      includeInTotal = false;
    }
    var newItem = __assign({
      count: 1
    }, item);
    this.items.push(newItem);
    if (includeInTotal) {
      this.total.amount += (_a = newItem.amount) === null || _a === void 0 ? void 0 : _a.amount;
      this.total.currency_id = (_b = newItem.amount) === null || _b === void 0 ? void 0 : _b.currency_id;
    }
  };
  return CReceipt;
}();
exports.CReceipt = CReceipt;
